import React from "react";
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import MetricsCard from "../../components/clientApp/MetricsCard";
import ClientList from "../../components/clientApp/ClientList";
import { Smartphone, Wifi, TrendingUp } from "lucide-react";

const ClientApp = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Mock data for client metrics
  const metrics = [
    {
      icon: <Smartphone size={32} />,
      title: "Total Clients",
      value: "12",
      color: 'var(--fx-text-primary)'
    },
    {
      icon: <Wifi size={32} />,
      title: "Connected",
      value: "8",
      color: colors.secondary[500]
    },
    {
      icon: <TrendingUp size={32} />,
      title: "Training",
      value: "3",
      color: colors.primary[400]
    }
  ];

  // Mock data for connected clients
  const connectedClients = [
    {
      id: 1,
      name: "Mobile Client 01",
      type: "smartphone",
      lastSeen: "1 min ago",
      battery: "85%",
      status: "connected",
      statusColor: colors.secondary[500]
    },
    {
      id: 2,
      name: "Desktop Client 02",
      type: "desktop",
      lastSeen: "active",
      battery: "100%",
      status: "training",
      statusColor: colors.primary[500]
    },
    {
      id: 3,
      name: "Tablet Client 03",
      type: "tablet",
      lastSeen: "5 min ago",
      battery: "67%",
      status: "idle",
      statusColor: colors.grey[500]
    },
    {
      id: 4,
      name: "Laptop Client 04",
      type: "laptop",
      lastSeen: "2 hours ago",
      battery: "45%",
      status: "disconnected",
      statusColor: colors.grey[400]
    }
  ];

  return (
    <Box sx={{ p: 3, maxWidth: 1440, mx: "auto" }}>
      <Header
        icon={<Smartphone size={18} />}
        title="Client App"
        subtitle="Monitor and manage federated learning client applications."
      />

      <MetricsCard metrics={metrics} />
      <ClientList clients={connectedClients} />
    </Box>
  );
};

export default ClientApp;
